export default "__VITE_ASSET__8d19cc02__"